
import useGlobal from '../../../store';
import { Transaction } from '../../components/transaction';
import useReloadDummy from '../../../scripts/hooks/use.reload.dummy';
import { usePopup } from '../popup';

const PopupDealInfo = ( props ) => {

  const [ Dummy, reloadDummy ] = useReloadDummy();
  const [ globalState, globalActions ] = useGlobal();

  const { 

    popup_deal_info,
    tariff_comission,
    deal_price_watch_mode,

  } = globalState;

  const { popup, deals, changeStates, changeObjectState } = globalActions;

  const {

    id,
    name,
    type,
    result,
    movements,
    amount,
    comment,
    date_create,
    date_update,
    
  } = popup_deal_info;

  const CONTENT = (

    <Transaction

      viewMode
      id = { id }
      name = { name }
      type = { type }
      result = { result }
      movements = { movements }
      amount = { amount || "" }
      comment = { comment || "" }
      setComment = { cmnt => changeObjectState( "popup_deal_info", "comment", cmnt ) }
      saveComment = { cmnt => { deals.comment( id, cmnt, true ) }}
      date_create = { date_create }
      date_update = { date_update }
      tariff_comission = { tariff_comission }
      price_watch_mode = { deal_price_watch_mode }
      actionRemoveDeal = { deals.remove }
      actionRemoveMovement = { ( obj ) => { deals.movement.remove( obj, reloadDummy ) } }
      
    />

  );

  const thisPopup = usePopup({ name: "deal_info", content: CONTENT })

  return thisPopup;

}

export default PopupDealInfo;